import styled from "styled-components";

export const DetailImgContainer = styled.img`
    width: 50%;
    height: 50%;
`

export const DetailRowContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.5rem;
`
